module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./NotFoundView.js"));
	}, "NotFoundView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=NotFoundView!./src/widget/NotFound/NotFoundView.js
// module id = 1609
// module chunks = 367